import { Col, Table, Select, Form } from 'antd';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSubObservations } from '../../SubObservations/redux/actions';
import {
  sortSubObservationsRequest,
  updateAllSubObservations,
} from '../../QuoteStatuses/redux/actions';
import SpinnerComponent from '../../../components/spinner';
import { ReactComponent as SaveIcon } from '../../../assets/save-icon.svg';
import { ReactComponent as EditIcon } from '../../../assets/edit-icon.svg';
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from 'react-sortable-hoc';
import DragDropIcon from '../../../assets/dragdropicon.png';
import { arrayMoveImmutable } from 'array-move';
import { useParams } from 'react-router-dom';

const SubObservationsv2 = ({
  record,
  currentNpoObj,
  canUpdate,
  observationId,
}) => {
  const params = useParams();
  const dispatch = useDispatch();
  const { subObservations } = useSelector(
    (state) => state.observationSubObservationsReducer
  );

  const { allSubObservations } = useSelector(
    (state) => state.subObservationsReducer
  );

  const subObservationsIds =
    subObservations.map((el) => el.sub_observation_id) || [];

  const SortableItem = SortableElement((props) => <tr {...props} />);
  const SortableBody = SortableContainer((props) => <tbody {...props} />);
  const DragHandle = SortableHandle(() => <img alt='' src={DragDropIcon} />);

  const [isEditObservations, setIsEditObservations] = useState(false);
  const [editingKey, setEditingKey] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [subObservationOptions, setSubObservationOptions] = useState([]);
  const [subObservationSelected, setSubObservationSelected] =
    useState(subObservationsIds);
  // const [selectedObservation, setSelectedObservation] = useState(null);
  const [observationSelect, setObservationSelect] = useState(null);
  const isEditing = (record) => record.key === editingKey;

  // const DraggableContainer = (props) => (
  //   <SortableBody
  //     useDragHandle
  //     disableAutoscroll
  //     helperClass='row-dragging'
  //     onSortEnd={onSortEnd}
  //     {...props}
  //   />
  // );

  // const DraggableBodyRow = ({ className, style, ...restProps }) => {
  //   const index = data.findIndex(
  //     (x) => x.position == restProps['data-row-key']
  //   );

  //   return (
  //     <SortableItem
  //       index={index}
  //       {...restProps}
  //       style={{ ...style, width: '100%' }}
  //     />
  //   );
  // };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      const newData = arrayMoveImmutable(data, oldIndex, newIndex);

      const updatedData = newData.map((el) => ({
        sub_observation_id: el.key,
      }));

      const payload = {
        learning_activity_id: params.id,
        observation_id: observationId,
        data: updatedData,
      };

      dispatch(sortSubObservationsRequest(payload));

      setData(
        newData.map((item, index) => ({
          ...item,
          position: index + 1,
        }))
      );
    }
  };

  useEffect(() => {
    dispatch(fetchSubObservations());
  }, [dispatch]);

  useEffect(() => {
    if (allSubObservations) {
      setSubObservationOptions(
        allSubObservations.map((sub) => ({
          label: sub.name,
          value: sub._id,
        }))
      );
    }
  }, [allSubObservations]);

  useEffect(() => {
    if (currentNpoObj?.learning_activity_observations) {
      setObservationSelect(null);
    }
  }, [currentNpoObj]);

  const handleEditClick = () => {
    setIsEditObservations(true);
  };

  const handleSave = async () => {
    setIsEditObservations(false);
    // if (selectedObservation) {
    const previousSubObservations = subObservationsIds || [];
    const updatedSubObservations = subObservationSelected || [];

    const removedSubObservations = previousSubObservations
      .filter((id) => !updatedSubObservations.includes(id))
      .map((id) => ({
        subObservation_id: id,
        subObservation_name: findSubObservationName(id),
        action: 'remove',
      }));

    const addedSubObservations = updatedSubObservations
      .filter((id) => !previousSubObservations.includes(id))
      .map((id) => ({
        subObservation_id: id,
        subObservation_name: findSubObservationName(id),
        action: 'add',
      }));

    const payload = {
      learning_activity_id: params.id,
      observation_id: observationId,
      subObservations: [...removedSubObservations, ...addedSubObservations],
    };

    dispatch(updateAllSubObservations(payload));

    // setTimeout(() => {
    // const formattedData = updatedSubObservations.map((id, index) => {
    //   const subObs = allSubObservations.find((item) => item._id === id);
    //   return {
    //     key: id,
    //     position: index + 1,
    //     sub_observation: {
    //       name: subObs ? subObs.name : "Unknown",
    //       icon: subObs ? subObs.icon : null,
    //     },
    //   };
    // });

    // setData(formattedData);
    // }
  };

  const findSubObservationName = (id) => {
    const subObservation = allSubObservations.find((item) => item._id === id);
    return subObservation ? subObservation.name : 'Unknown';
  };

  function sanitizeAndResizeSvg(svg, maxWidth = 50, maxHeight = 50) {
    if (!svg) return '';
    return svg.replace(
      /<svg([^>]*)>/,
      `<svg$1 style="max-width:${maxWidth}px; max-height:${maxHeight}px;"`
    );
  }

  const subColumns = [
    {
      title: 'Sub Observation Title',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      width: '30%',
      render: (_, record) => <div>{record?.sub_observation?.name}</div>,
    },
    {
      title: 'Position',
      dataIndex: 'position',
      key: 'position',
      align: 'center',
      width: '20%',
    },
    {
      title: 'Icon',
      dataIndex: 'icon',
      key: 'icon',
      align: 'center',
      width: '30%',
      render: (_, record) =>
        record?.sub_observation?.icon ? (
          <div
            dangerouslySetInnerHTML={{
              __html: sanitizeAndResizeSvg(record?.sub_observation?.icon),
            }}
          />
        ) : null,
    },
    {
      title: 'Status',
      dataIndex: 'deleted_status',
      key: 'deleted_status',
      align: 'left',
      width: '35%',

      render: (_, record) => (
        <div style={{ textTransform: 'uppercase' }}>
          {record?.sub_observation?.deleted_status}
        </div>
      ),
    },

    {
      title: 'Order',
      dataIndex: 'order',
      key: 'order',
      width: '20%',
      className: 'drag-visible',
      align: 'center',
      render: (order, record) => {
        return !Boolean(editingKey) && canUpdate && <DragHandle />;
      },
    },
  ];

  const mergedColumns = subColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: 'text',
        dataIndex: col.dataIndex,
        editing: isEditing(record),
      }),
    };
  });

  useEffect(() => {
    if (subObservations) {
      const formattedData = subObservations
        .map((item, index) => ({
          key: item.sub_observation_id,
          position: item.position,
          sub_observation: {
            name: item?.name || 'Unknown',
            icon: item.icon || null,
            deleted_status: item?.deleted_status || 'active',
          },
        }))
        .sort((a, b) => a.position - b.position);
      setData(formattedData);
    }
  }, [subObservations]);

  return (
    <>
      <Col
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        <label className='custom-label'>Sub Observation</label>
        <Select
          mode='multiple'
          size='middle'
          style={{ flex: 1 }}
          // placeholder={isEditObservations ? "" : ""}
          // placeholder=""
          placeholder={!isEditObservations ? '' : 'Select Sub Observation'}
          value={subObservationSelected}
          onChange={setSubObservationSelected}
          options={subObservationOptions}
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
          disabled={!isEditObservations}
        />

        {isEditObservations ? (
          loading ? (
            <SpinnerComponent fontSize={14} />
          ) : (
            <SaveIcon
              width={20}
              height={15}
              fill='#50B6F2'
              onClick={handleSave}
            />
          )
        ) : (
          canUpdate && (
            <EditIcon
              width={20}
              height={15}
              // fill="#e21c21"
              fill='#50B6F2'
              onClick={handleEditClick}
            />
          )
        )}
      </Col>

      <br />
      <Table
        className='custom-expanded-table table-second-level'
        style={{ marginTop: '0px' }}
        components={{
          body: {
            wrapper: (props) => (
              <SortableBody
                useDragHandle
                disableAutoscroll
                helperClass='row-dragging'
                onSortEnd={onSortEnd}
                {...props}
              />
            ),
            row: (props) => (
              <SortableItem
                index={data.findIndex((x) => x.key === props['data-row-key'])}
                {...props}
              />
            ),
          },
        }}
        pagination={false}
        columns={mergedColumns}
        // dataSource={record?.learning_activity_sub_observations || []}
        dataSource={data}
      />
    </>
  );
};

export default SubObservationsv2;
